import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { typesOfIcon, sizes } from '../../constants/icon-constants';
import IconWrapper from '../icon-wrapper/icon-wrapper.vue';

export interface IconMessageProps {
  iconType?: keyof typeof typesOfIcon;
  iconSize?: keyof typeof sizes;
}

 
export default /*#__PURE__*/_defineComponent({
  __name: 'icon-message',
  props: {
    iconType: { default: 'info' },
    iconSize: { default: 'small' }
  },
  setup(__props: any) {

const props = __props as { iconType: keyof typeof typesOfIcon, iconSize: keyof typeof sizes };



const getIconTypeClass = computed(() => {
  return props.iconType ? `icon-message--${props.iconType}` : '';
})

return { __sfc: true,props, getIconTypeClass, IconWrapper }
}

})